import React, { useState, useEffect } from "react";
import { GetVirtualVerify } from "../../../../services/collegeRequests";
import { useParams } from "react-router-dom";

const VirtualVerification = ({ mentorId, mentorData }) => {
  const [virtualData, setVirtualData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    const fetchVirtualVerificationData = async () => {
      try {
        setLoading(true);
        const response = await GetVirtualVerify(id);
        if (response.data && response.data.result) {
          setVirtualData(response.data.result);
        }
      } catch (error) {
        console.error("Error fetching virtual verification data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchVirtualVerificationData();
    }
  }, [id]);

  const formatDate = (dateString) => {
    if (!dateString) return "Not Scheduled";
    return new Date(dateString).toLocaleDateString("en-GB");
  };

  const formatTime = (timeString) => {
    if (!timeString) return "Not Scheduled";
    return new Date(`1970-01-01T${timeString}Z`).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const callCreate = () => {
    if (!virtualData) return;

    const callUrl = `https://video-call-firebase-kgfu.vercel.app/meet?type=create&user=student&callerName=${
      virtualData.name
    }&calleeName=${
      mentorData?.firstName + " " + mentorData?.lastName
    }&calleeId=${mentorId}&callerId=${virtualData.admin_id}&chatId=1020`;

    window.open(callUrl, "_blank");
  };

  if (loading) {
    return <div className="mt-4">Loading virtual verification details...</div>;
  }

  if (!virtualData) {
    return <div className="mt-4">No virtual verification data available</div>;
  }

  return (
    <div className="mt-4 d-flex flex-wrap gap-4">
      {/* Main Verification Card */}
      <div
        className="card shadow p-3"
        style={{
          width: "400px",
          borderRadius: "10px",
          backgroundColor: "#ffffff",
        }}
      >
        <button className="btn btn-primary btn-lg mb-4">
          Schedule Verification
        </button>

        <div className="card-body">
          <p className="mb-3" style={{ color: "black" }}>
            <strong>Date:</strong> {formatDate(virtualData.schedule_date)}
          </p>
          <p className="mb-3" style={{ color: "black" }}>
            <strong>Time:</strong> {formatTime(virtualData.start_time)} -{" "}
            {formatTime(virtualData.end_time)}
          </p>
          <p className="mb-3" style={{ color: "black" }}>
            <strong>Name:</strong> {virtualData.name}
          </p>
          <p className="mb-3" style={{ color: "black" }}>
            <strong>Email:</strong> {virtualData.email_id}
          </p>
          <p className="mb-3" style={{ color: "black" }}>
            <strong>Role:</strong> {virtualData.role.replace(/_/g, " ")}
          </p>
          <p className="mb-3" style={{ color: "black" }}>
            <strong>Timezone:</strong> {virtualData.timezone}
          </p>
          <p className="mb-3" style={{ color: "black" }}>
            <strong>Session ID:</strong> {virtualData.session_id}
          </p>
          <p className="mb-3" style={{ color: "black" }}>
            <strong>Status:</strong>{" "}
            {virtualData.schedule_date ? "Scheduled" : "Not Scheduled"}
          </p>
        </div>
        <div className="d-flex justify-content-between">
          <div></div>
          <button
            onClick={callCreate}
            className="btn btn-primary btn-lg"
            disabled={!virtualData.schedule_date}
          >
            Join Call
          </button>
          <div></div>
        </div>
      </div>

      {/* Things to Remember Card (if available) */}
      {virtualData.things_to_remember && (
        <div
          className="card shadow p-3"
          style={{
            width: "400px",
            borderRadius: "10px",
            backgroundColor: "#ffffff",
          }}
        >
          <button className="btn btn-secondary btn-lg mb-4">
            Instructions
          </button>
          <div className="card-body">
            <p style={{ color: "black" }}>{virtualData.things_to_remember}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default VirtualVerification;
